export { default } from './TaskExecItem';



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsLists/_items/TaskExecItem/index.js